var map = {
	"./analysis.svg": 7637,
	"./dashboard.svg": 58749,
	"./distribution.svg": 45473,
	"./example.svg": 49892,
	"./eye-open.svg": 14301,
	"./eye.svg": 34986,
	"./form.svg": 74062,
	"./group.svg": 81284,
	"./icon-admin.svg": 44340,
	"./icon-bianji.svg": 42115,
	"./icon-config.svg": 82984,
	"./icon-dangdifill.svg": 41087,
	"./icon-daohang.svg": 88708,
	"./icon-duanxin.svg": 14158,
	"./icon-editor.svg": 98001,
	"./icon-form.svg": 79086,
	"./icon-geren.svg": 57765,
	"./icon-jiesuo.svg": 18656,
	"./icon-job.svg": 38779,
	"./icon-log.svg": 88722,
	"./icon-menu.svg": 70827,
	"./icon-mudedi.svg": 35751,
	"./icon-order.svg": 58969,
	"./icon-oss.svg": 36892,
	"./icon-pinglun.svg": 10165,
	"./icon-prod.svg": 92239,
	"./icon-role.svg": 82979,
	"./icon-shanchu.svg": 34230,
	"./icon-shezhi.svg": 37624,
	"./icon-shoucang.svg": 9723,
	"./icon-shoucangfill.svg": 50758,
	"./icon-shouye.svg": 26850,
	"./icon-sousuo.svg": 15202,
	"./icon-sql.svg": 15467,
	"./icon-store.svg": 65841,
	"./icon-suoding.svg": 75287,
	"./icon-system.svg": 34691,
	"./icon-tixing.svg": 58503,
	"./icon-tubiao.svg": 28134,
	"./icon-vip.svg": 58183,
	"./icon-xiangqu.svg": 17022,
	"./icon-xiangqufill.svg": 53208,
	"./icon-zhedie.svg": 82950,
	"./icon-zonghe.svg": 89000,
	"./index-select.svg": 65745,
	"./index.svg": 29770,
	"./language.svg": 59424,
	"./link.svg": 14121,
	"./live.svg": 21528,
	"./nested.svg": 91476,
	"./order.svg": 93207,
	"./password.svg": 46408,
	"./product.svg": 16967,
	"./promotion.svg": 59596,
	"./report.svg": 17674,
	"./shop.svg": 99627,
	"./table.svg": 3797,
	"./tree.svg": 40964,
	"./user.svg": 30042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;